import { render, staticRenderFns } from "./braiding-and-plaiting-skills.vue?vue&type=template&id=2a60da2a&scoped=true&"
import script from "./braiding-and-plaiting-skills.vue?vue&type=script&lang=js&"
export * from "./braiding-and-plaiting-skills.vue?vue&type=script&lang=js&"
import style0 from "./braiding-and-plaiting-skills.vue?vue&type=style&index=0&id=2a60da2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a60da2a",
  null
  
)

export default component.exports